import axios from "axios";
import {
  ManagedUserCreate,
  ManagedUserResponse,
} from "../../types/models/users/managedUser";
import { UserUpdate } from "../../types/models/users/user";

const REACT_APP_API_URL = process.env.REACT_APP_API_URL || "http://127.0.0.1:8000";

const getAuthHeaders = () => {
  const token = localStorage.getItem("authToken");
  if (!token) {
    throw new Error("Unauthorized: No token found.");
  }
  return {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };
};

export const getDetailedManagedUserInfo = async () => {
  const token = localStorage.getItem("authToken");
  if (!token) {
    throw new Error("Unauthorized: No token found.");
  }

  try {
    const response = await axios.get(`${REACT_APP_API_URL}/client-admin/info`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error(`Error fetching detailed user info:`, error);
    throw new Error(`Failed to fetch detailed user info.`);
  }
};

export const updateManagedUser = async (
  data: UserUpdate
): Promise<void> => {
  const token = localStorage.getItem("authToken");

  if (!token) {
    throw new Error("Unauthorized: No token found.");
  }

  const response = await fetch(`${REACT_APP_API_URL}/client-admin/update`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    let errorMessage = "Failed to update user";
    try {
      const errorData = await response.json();
      errorMessage = errorData.message || errorMessage;
    } catch (_) {}
    throw new Error(errorMessage);
  }
  return;
};


export const getAllManagedUsers = async (
  skip: number = 0,
  limit: number = 100
): Promise<ManagedUserResponse[]> => {
  try {
    const response = await axios.get(`${REACT_APP_API_URL}/client-admin/users`, {
      headers: getAuthHeaders(),
      params: { skip, limit },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching managed users:", error);
    throw new Error("Failed to fetch managed users.");
  }
};

export const createManagedUser = async (
  data: ManagedUserCreate
): Promise<ManagedUserResponse> => {
  try {
    const response = await axios.post(`${REACT_APP_API_URL}/client-admin/`, data, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error("Error creating managed user:", error);
    throw new Error("Failed to create managed user.");
  }
};

export const deleteManagedUser = async (userId: number): Promise<boolean> => {
  try {
    const response = await axios.delete(
      `${REACT_APP_API_URL}/client-admin/delete`,
      {
        headers: getAuthHeaders(),
        params: { user_id: userId },
      }
    );
    return response.status === 200;
  } catch (error) {
    console.error("Error deleting managed user:", error);
    throw new Error("Failed to delete managed user.");
  }
};

